import { Component, HostBinding, ChangeDetectorRef, NgZone } from '@angular/core';
import { CustErrorHandler } from './app.error.handler';
import { Router, Event, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { LoaderService } from './services/loader.service';
import { SegmentService } from './services/segment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  providers: [CustErrorHandler]
})
export class AppComponent {

  constructor(public ref: ChangeDetectorRef, public errHandler: CustErrorHandler, public router: Router,
    public loaderService: LoaderService, public zone: NgZone, public segmentService: SegmentService) {
    if (this.segmentService.checkToRunSegment()) {
      (<any>window).analytics.load(environment.APP.SEGMENT_TRACKING);
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          (<any>window).analytics.page();
        }
      });
    }
  }

	@HostBinding('class.no-touch')
	doesNotHaveTouch = !("ontouchstart" in document.documentElement);

	ngAfterViewInit() {
    //Disable angular auto change detection
    this.ref.detach();

    let w = (<any>window);
    w.domBody.classList.remove('show-loading-grey');

		w.Events.subscribe('detectChanges',()=>{
			this.ref.detectChanges();
		});

    w.Events.subscribe('error',(err)=>{
      this.errHandler.handleError(err);
    });

    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !w.MSStream;
    let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if(!(isSafari && iOS)) {
      if ('addEventListener' in document && w.FastClick) {
        this.overrideFastClickPrototype();
        document.addEventListener('DOMContentLoaded', function() {
          w.FastClick.attach(document.body);
        }, false);
      }
    }

	}

  overrideFastClickPrototype() {
    let w = (<any>window);
    let deviceIsWindowsPhone = navigator.userAgent.indexOf('Windows Phone') >= 0;
    let deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
    w.FastClick.prototype.needsClick = function(target) {
      switch (target.nodeName.toLowerCase()) {

      // Don't send a synthetic click to disabled inputs (issue #62)
      case 'button':
      case 'select':
      case 'textarea':
        if (target.disabled) {
          return true;
        }

        break;
      case 'input':

        // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
        if ((deviceIsIOS && target.type === 'file') || target.disabled) {
          return true;
        }

        break;
      case 'label':
      case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
      case 'video':
        return true;
      }

      return (/\bneedsclick\b/).test(target.className)
      || (/\bonoffswitch-inner\b/).test(target.className)
      || (/\bonoffswitch-switch\b/).test(target.className)
      || (/\bonoffswitch-label\b/).test(target.className)
      || (/\bonoffswitch-checkbox\b/).test(target.className)
      || (/\bonoffswitch\b/).test(target.className)

      || (/\bcontrol\b/).test(target.className)
      || (/\bcontrol-checkbox\b/).test(target.className)
      || (/\bcontrol-indicator\b/).test(target.className)
      || (/\bcheckbox-label\b/).test(target.className)
      || (/\bcontrol-radio\b/).test(target.className);
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts